module.exports = __webpack_public_path__ + "img/e4a1196.jpg";